var nombre = "SATEBCOWEB";
var host;
var hostweb;

switch (nombre) {
  case "SATEBCO":
    host = "http://192.168.0.3";
    hostweb = "https://satebco.pagosweb.com.ve";

    module.exports = {
      conexion: host + ":5010",
      timbreactu: "ws://192.168.0.3:2020",
      ipmac: host,
      ws: "ws://192.168.0.3:5010",
      servidor: hostweb + "/api",
      imagenes: host + ":5020/imagen?img=",
      imagenesweb: hostweb + "/api/imagen?img=",
      archivo: host + ":5020/archivo?nombre=",
      reportes: host + ":4000/stimbres?",
      reportesweb: hostweb + "/api2/satebco?",
      email: hostweb + "/api3/",
      nombre: nombre,
      logo: "escudo.png",
      color: "#007bff",
    };

    break;

  case "SATEBCOWEB":
    host = "https://satebco.timbresfiscales.com.ve";
    hostweb = "https://satebco.pagosweb.com.ve";

    module.exports = {
      conexion: host + "/api",
      timbreactu: host + "/actu",
      ipmac: host + "/ipmac",
      ws: host + "/ws",
      servidor: hostweb + "/api",
      imagenes: host + "/api/imagen?img=",
      imagenesweb: hostweb + "/api/imagen?img=",
      archivo: host + "/api/archivo?nombre=",
      reportes: host + "/api2/stimbres?",
      reportesweb: hostweb + "/api2/satebco?",
      email: host + "/api3/",
      nombre: nombre,
      logo: "escudo.png",
      color: "#007bff",
    };

    break;
  default:
    break;
}



//////////////////
// WEBPACK FOOTER
// ./public/modulos/datos.js
// module id = 5
// module chunks = 0